/*
 * copyToClipboard — click-to-copy for the internal icon-library reference
 * (/_docs/icons). Alpine CSP build: every template binding is a single named
 * method call or property read, so the per-tile copy logic (clipboard write +
 * transient "Copied" flag) lives here instead of an inline expression.
 *
 * The value to copy is read from the clicked button's `data-copy` attribute
 * (Alpine passes the native event as the first arg to a bare-method binding),
 * since the CSP parser can't interpolate a value into the binding itself.
 */
export default function copyToClipboard() {
    return {
        copied: '',
        _timer: null,

        copy(event) {
            const value = event.currentTarget?.dataset.copy ?? '';
            if (!value) return;

            navigator.clipboard?.writeText(value);
            this.copied = value;

            clearTimeout(this._timer);
            this._timer = setTimeout(() => {
                this.copied = '';
            }, 1200);
        },

        // Named property read for the CSP-build x-show binding on each toast.
        isCopied(name) {
            return this.copied === name;
        },

        destroy() {
            clearTimeout(this._timer);
        },
    };
}
